module.exports = __webpack_public_path__ + "static/img/poster.005bcdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/poster.png
// module id = PO4v
// module chunks = 1